import React from "react";
import classNames from "classnames";
import { IconProps } from "../type";

export const SummaryColorIcon = ({ className, style, ...props }: IconProps) => (
  <svg
    className={classNames(["h-full w-full", className])}
    style={style}
    {...props}
    viewBox='0 0 40 41'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M26.5957 14.0482C26.7692 14.7056 27.3842 15.159 28.0268 15.0919C28.3646 15.0655 28.6797 14.9117 28.9084 14.6618C29.1371 14.4118 29.2624 14.0844 29.2588 13.7456C29.2687 12.8546 29.2687 11.963 29.2588 11.0707C29.2617 10.7591 29.152 10.4569 28.9499 10.2197C28.7478 9.98256 28.467 9.82624 28.1589 9.7795C27.9137 9.73825 27.6654 9.71813 27.4167 9.71938C22.5123 9.71938 17.6083 9.71938 12.7045 9.71938C12.4426 9.71935 12.181 9.73912 11.922 9.77852C11.6016 9.825 11.3094 9.98746 11.1008 10.2351C10.8922 10.4827 10.7818 10.7983 10.7905 11.1219C10.7905 11.6068 11.0674 11.9528 11.3523 12.3046C13.5374 14.9717 15.7136 17.6466 17.9125 20.3029C18.2003 20.6508 18.1786 20.8656 17.9026 21.1988C16.1778 23.2774 14.4737 25.3728 12.7637 27.4633C12.1989 28.1532 11.6125 28.8274 11.0822 29.543C10.415 30.4448 10.9048 31.5575 12.0146 31.7231C12.2481 31.7557 12.4836 31.7715 12.7193 31.7704C15.1577 31.7704 17.5965 31.7704 20.0355 31.7704C22.4877 31.7704 24.9399 31.7704 27.3921 31.7704C27.6409 31.772 27.8895 31.7532 28.1353 31.7143C28.451 31.673 28.7403 31.5166 28.9477 31.275C29.1551 31.0334 29.2659 30.7237 29.2588 30.4054C29.2687 29.5262 29.2687 28.6477 29.2588 27.7698C29.2519 27.0188 28.7404 26.4639 28.0121 26.3969C27.3527 26.3358 26.7465 26.8049 26.5829 27.4939C26.509 27.8053 26.5396 28.1207 26.5346 28.4341C26.5277 28.9871 26.5188 29.0028 25.9541 29.0028C22.5058 29.0028 19.0561 29.0028 15.6052 29.0028C15.4662 29.0028 15.279 29.0689 15.2021 28.9309C15.1163 28.7762 15.3006 28.6825 15.3893 28.579C17.2291 26.3226 19.0713 24.0692 20.9157 21.8187C21.5376 21.0578 21.5326 20.43 20.9048 19.6681C20.3046 18.9398 19.7093 18.2084 19.111 17.4771C17.8501 15.9337 16.5895 14.3895 15.3292 12.8447C15.2652 12.7669 15.1439 12.694 15.1863 12.5826C15.2395 12.4446 15.3903 12.4958 15.5007 12.4929C15.7501 12.485 15.9994 12.4929 16.2478 12.4929H25.8082C26.5317 12.4929 26.5297 12.4929 26.5327 13.2331C26.5187 13.5064 26.5399 13.7803 26.5957 14.0482Z'
      fill='url(#paint0_linear_1567_23539)'
    />
    <path
      d='M19.999 0.714844C8.9533 0.714844 -0.000976562 9.66912 -0.000976562 20.7148C-0.000976562 31.7606 8.9533 40.7149 19.999 40.7149C31.0448 40.7149 39.999 31.7606 39.999 20.7148C39.999 9.66912 31.0448 0.714844 19.999 0.714844ZM20.0227 38.1444C10.4495 38.1365 2.62173 30.3423 2.62568 20.7198C2.62568 11.1505 10.4652 3.3346 20.0286 3.34347C29.6245 3.35136 37.4857 11.1732 37.4108 20.7671C37.4719 30.3413 29.5851 38.1523 20.0227 38.1444Z'
      fill='url(#paint1_linear_1567_23539)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_1567_23539'
        x1='-0.000976563'
        y1='0.714844'
        x2='41.4646'
        y2='2.29663'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_1567_23539'
        x1='-0.000976563'
        y1='0.714844'
        x2='41.4646'
        y2='2.29663'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
    </defs>
  </svg>
);
